import * as CookieConsent from 'vanilla-cookieconsent';
import {handleUpdateGA4Consent} from "./google-analytics-service";

/** KONFIGURACJA COOKIES */
function getCookieConsentConfig(): UserConfig {
    return {
        current_lang: 'pl',
        autoclear_cookies: true,
        cookie_domain: 'fakturomania.pl',
        cookie_name: 'fakturomania_cookie_consent',
        cookie_expiration: 180,
        cookie_same_site: 'Strict',
        page_scripts: true,
        gui_options: {
            consent_modal: {
                layout: 'box',
                position: 'bottom right',
                transition: 'slide'
            },
            settings_modal: {
                layout: 'box',
                transition: 'slide'
            }
        },
        onAccept: (savedCookieContent) => {
            handleUpdateCookieConsent(savedCookieContent.categories);
        },
        onChange: (cookie, changedCookieCategories) => {
            handleUpdateCookieConsent(cookie.categories);
        },
        languages: {
            'pl': {
                consent_modal: {
                    title: ' Używamy plików cookie! ',
                    description: 'Witaj! Ta strona korzysta z niezbędnych plików cookie, aby zapewnić jej prawidłowe działanie. Dodatkowo używamy plików cookie śledzących, aby lepiej zrozumieć, jak z niej korzystasz. Te ostatnie zostaną zapisane tylko za Twoją zgodą. <button type="button" data-cc="c-settings" class="cc-link">Dostosuj ustawienia</button>',
                    primary_btn: {
                        text: 'Zaakceptuj wszystkie',
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Tylko niezbędne',
                        role: 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Fakturomania.pl - Polityka plików cookie',
                    save_settings_btn: 'Zapisz ustawienia',
                    accept_all_btn: 'Zaakceptuj wszystkie',
                    reject_all_btn: 'Odrzuć wszystkie',
                    close_btn_label: 'Zamknij',
                    cookie_table_headers: [
                        { col1: 'Nazwa' },
                        { col2: 'Domena' },
                        { col3: 'Czas przechowywania' },
                        { col4: 'Opis' }
                    ],
                    blocks: [
                        {
                            title: 'Wykorzystanie plików cookie 📢',
                            description: 'Pliki cookie są używane do zapewnienia podstawowej funkcjonalności strony oraz do poprawy Twojego doświadczenia. Możesz zarządzać zgodą dla każdej kategorii. Szczegółowe informacje znajdziesz w <a href="https://fakturomania.pl/cookies" target="_blank" class="cc-link">polityce prywatności</a>.'
                        }, {
                            title: 'Niezbędne pliki cookie',
                            description: 'Te pliki cookie są wymagane do prawidłowego działania strony i nie można ich wyłączyć.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            }
                        }, {
                            title: 'Analityczne pliki cookie',
                            description: 'Pliki te pomagają w analizowaniu, jak użytkownicy korzystają ze strony.',
                            toggle: {
                                value: 'analytics',
                                enabled: true,
                                readonly: false
                            },
                            cookie_table: [
// GOOGLE ANALYTICS
                                {
                                    col1: '^_ga',
                                    col2: 'google.com',
                                    col3: '2 lata',
                                    col4: '[Google] - Służy do analizy ruchu na stronie.',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: 'google.com',
                                    col3: '1 dzień',
                                    col4: '[Google] - Identyfikacja unikalnych użytkowników.',
                                },
                                // FRESHDESK
                                {
                                    col1: '_fw_crm_v',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: '1 rok',
                                    col4: '[Freshchat/Freshworks] - Plik cookie (używany do śledzenia tożsamości odwiedzającego/użytkownika i sesji czatu prowadzonych przez użytkownika).',
                                },
                                {
                                    col1: '_x_w',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Zawiera identyfikator fragmentu, na którym działa konto.',
                                },
                                {
                                    col1: '_x_m',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Zawiera stan fragmentu.',
                                },
                                {
                                    col1: '_helpkit_session',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Twój tajny klucz do weryfikacji integralności danych sesji plików cookie. Jeśli zmienisz ten klucz, wszystkie stare sesje stracą ważność!',
                                },
                                {
                                    col1: 'helpdesk_node_session',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Zaszyfrowany hash przechowujący tajny klucz i identyfikator próby logowania.',
                                },
                                {
                                    col1: 'user_credentials',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: '2 miesiące',
                                    col4: '[Freshchat/Freshworks] - Używany do uwierzytelniania użytkownika.',
                                },
                                {
                                    col1: 'wf_order',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Służy do sprawdzenia, w jakiej kolejności zgłoszenia są filtrowane dla niestandardowych filtrów zgłoszeń, np.: termin, odpowiedź konsultanta o, odpowiedź zgłaszającego o, itp.',
                                },
                                {
                                    col1: 'wf_order_type',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Służy do sprawdzania, czy kolejność jest rosnąca, czy malejąca dla niestandardowych filtrów zgłoszeń.',
                                },
                                {
                                    col1: 'wf_filter',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Wskazuje, który filtr jest stosowany do listy zgłoszeń.',
                                },
                                {
                                    col1: '__cf_bm',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Ciasteczko od Cloudflare jest używane do identyfikacji i ograniczenia ruchu automatycznego, co ma na celu ochronę Twojej strony przed szkodliwymi botami. Ciasteczko to pomaga w rozróżnianiu ludzkich użytkowników od botów, co jest kluczowe dla bezpieczeństwa i wydajności witryny, zapobiegając nadużyciom i atakom.',
                                }
                            ]
                        }, {
                            title: 'Reklamowe i marketingowe pliki cookie',
                            description: 'Pliki cookie śledzące pozwalają dostosować reklamy do Twoich preferencji.',
                            toggle: {
                                value: 'targeting',
                                enabled: true,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'hp2_id',
                                    col2: 'freshworks.com',
                                    col3: '2 lata',
                                    col4: '[Freshchat/Freshworks] - Ciasteczka te mogą być umieszczane na naszej stronie przez naszych partnerów reklamowych. Służą do tworzenia profilu Twoich zainteresowań i wyświetlania odpowiednich reklam na innych stronach. Nie przechowują bezpośrednio informacji osobistych, ale opierają się na unikalnym identyfikowaniu Twojej przeglądarki i urządzenia internetowego. Jeśli ich nie zaakceptujesz, będziesz otrzymywać mniej spersonalizowane reklamy.'
                                }
                            ]
                        }
                    ]
                }
            }
        }
    } as UserConfig;
}

export function handleInitializeCookieConsent() {
    console.log("Initializing Cookie Consent");
    const cc: CookieConsent = window.initCookieConsent();

    // JEŚLI WCZYTAL SIE COOKIE CONSENT LIBRARY
    // ALE NIE MA WAZNEGO USTAWIENIA COOKIES
    if (cc) {
        console.log("Cookie Consent not found: running initialization");
        const config: UserConfig = getCookieConsentConfig();
        cc.run(config);
    }

    // JEŻELI JUZ WCZENIEJ PRAWIDŁOWO USTAWIŁ
    else {
        console.log("Cookie Consent already valid");
    }
}

function handleUpdateCookieConsent(allowedCategories: string[]) {
    // DANE UNIWERSALNE
    const analyticsGranted: boolean = allowedCategories.indexOf('analytics') > -1;
    const advertisingGranted: boolean = allowedCategories.indexOf('targeting') > -1;
    handleUpdateGA4Consent(analyticsGranted,advertisingGranted);
}


// WEBPACK FOOTER //
// ./src/services/cookie-consent-service.ts